import React, { useState } from 'react';
import { Table, Button, Card, Form, Row, Col } from 'react-bootstrap';
import { FaPlus, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const formatarData = (valor) => {
  if (valor == null) return '-';
  const dt = new Date(valor);
  if (isNaN(dt.getTime())) return valor;
  const mes = String(dt.getMonth() + 1).padStart(2, '0');
  const ano = dt.getFullYear();
  return mes + '/' + ano;
};

const GridExpectativa = ({ codigoFamilia, expectativas, permissoes, onRecarregar }) => {
  const [showForm, setShowForm] = useState(false);
  const [mesAno, setMesAno] = useState('');
  const [percentual, setPercentual] = useState('');
  const [salvando, setSalvando] = useState(false);

  const handleIncluir = async () => {
    if (mesAno === '') {
      toast.error('Informe o Mês/Ano.');
      return;
    }
    if (percentual === '' || Number(percentual) <= 0) {
      toast.error('Percentual deve ser maior que zero.');
      return;
    }
    const partes = mesAno.split('-');
    const dataFormatada = partes[0] + '-' + partes[1] + '-01';
    setSalvando(true);
    try {
      await api.incluirExpectativaConfig({
        codigo_familia: codigoFamilia,
        data: dataFormatada,
        percentual: Number(percentual),
      });
      toast.success('Expectativa incluída!');
      setShowForm(false);
      setMesAno('');
      setPercentual('');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao incluir expectativa';
      toast.error(msg);
    } finally {
      setSalvando(false);
    }
  };

  const handleExcluir = async (item) => {
    if (!window.confirm('Excluir a expectativa de ' + formatarData(item.data) + '?')) return;
    try {
      await api.excluirExpectativaConfig({
        codigo_familia: codigoFamilia,
        data: item.data,
      });
      toast.success('Expectativa excluída!');
      onRecarregar();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao excluir expectativa';
      toast.error(msg);
    }
  };

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center py-2">
        <strong>Expectativa de Vendas</strong>
        {permissoes.projeto && !showForm && (
          <Button size="sm" variant="outline-success" onClick={() => setShowForm(true)}>
            <FaPlus className="mr-1" /> Incluir
          </Button>
        )}
      </Card.Header>
      <Card.Body className="p-0">
        {showForm && (
          <div className="p-3 border-bottom bg-light">
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Mês/Ano *</Form.Label>
                  <Form.Control type="month" value={mesAno} onChange={(e) => setMesAno(e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Form.Group>
                  <Form.Label>Percentual % *</Form.Label>
                  <Form.Control type="number" step="0.01" value={percentual} onChange={(e) => setPercentual(e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={4} className="d-flex align-items-end">
                <Button size="sm" variant="success" className="mr-2" onClick={handleIncluir} disabled={salvando}>
                  <FaPlus className="mr-1" /> Incluir
                </Button>
                <Button size="sm" variant="secondary" onClick={() => setShowForm(false)} disabled={salvando}>
                  Cancelar
                </Button>
              </Col>
            </Row>
          </div>
        )}
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
        <Table striped bordered hover size="sm" className="mb-0">
          <thead>
            <tr>
              <th>Data</th>
              <th>Percentual (%)</th>
              <th>Valor</th>
              <th>Acumulado</th>
              {permissoes.projeto && <th style={{ width: 60 }}>Ação</th>}
            </tr>
          </thead>
          <tbody>
            {expectativas.length === 0 && (
              <tr>
                <td colSpan={permissoes.projeto ? 5 : 4} className="text-center text-muted">
                  Nenhuma expectativa cadastrada
                </td>
              </tr>
            )}
            {expectativas.map((item) => (
              <tr key={'expectativa-' + item.data}>
                <td>{formatarData(item.data)}</td>
                <td>{item.percentual}</td>
                <td>{item.valor}</td>
                <td>{item.acumulado}</td>
                {permissoes.projeto && (
                  <td>
                    <Button size="sm" variant="outline-danger" title="Excluir" onClick={() => handleExcluir(item)}>
                      <FaTrash />
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GridExpectativa;
